var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [
            {
              text: "Pending Applications",
              path: { name: "admin-applications" },
            },
          ],
          name: _vm.companyName,
          "no-title": "",
        },
      }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { lg: "6", md: "8" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { "with-header": "", "with-footer": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "header",
                      fn: function () {
                        return [
                          _c("h2", { staticClass: "text-center mb-0" }, [
                            _vm._v(_vm._s(_vm.companyName)),
                          ]),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            { staticClass: "text-center" },
                            [
                              _c(
                                "b-btn",
                                {
                                  attrs: { variant: "success" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.approveApplication.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Approve Application")]
                              ),
                              _vm._v(" "),
                              _c(
                                "b-btn",
                                {
                                  attrs: { variant: "danger" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.rejectApplication.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                },
                                [_vm._v("Reject Application")]
                              ),
                            ],
                            1
                          ),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [
                  _vm._v(" "),
                  _vm._v(" "),
                  !_vm.loading
                    ? _c("div", [
                        _c("div", { staticClass: "mb-2" }, [
                          _c("h4", { staticClass: "mb-0" }, [_vm._v("Owner")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.application.user.name)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("h4", { staticClass: "mb-0" }, [_vm._v("Email")]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(_vm._s(_vm.application.user.email)),
                          ]),
                        ]),
                        _vm._v(" "),
                        _vm.application.user.phone
                          ? _c("div", { staticClass: "mb-2" }, [
                              _c("h4", { staticClass: "mb-0" }, [
                                _vm._v("Phone"),
                              ]),
                              _vm._v(" "),
                              _c("span", [
                                _vm._v(_vm._s(_vm.application.user.phone)),
                              ]),
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("h4", { staticClass: "mb-0" }, [
                            _vm._v("Date Applied"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.dateApplied))]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("h4", { staticClass: "mb-0" }, [
                            _vm._v("Facility License"),
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.application.license.type.name +
                                  " #" +
                                  _vm.application.license.number
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "mb-2" }, [
                          _c("h4", { staticClass: "mb-0" }, [
                            _vm._v("Facility Address"),
                          ]),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.addressStreetPart))]),
                          _c("br"),
                          _vm._v(" "),
                          _c("span", [_vm._v(_vm._s(_vm.addressCityPart))]),
                        ]),
                      ])
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("admin-application-approve-modal", {
        ref: "approveModal",
        on: { confirm: _vm.confirmApproveApplication },
      }),
      _vm._v(" "),
      _c("admin-application-reject-modal", {
        ref: "rejectModal",
        on: { confirm: _vm.confirmRejectApplication },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }